import React from 'react';
import { graphql } from 'gatsby';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';

import TwoColumns from '~/components/TwoColumns';

import DynamicComponent from '~/components/DynamicComponent';
import Grid2 from '~/components/Dynamic/Grid2';
import useStoryblok from '~/utils/storyblok-service';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';
import FeatureGrid from '~/components/Dynamic/FeatureGrid';

const HowItWorks = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;
  const hero = content?.hero[0];

  return (
    <Layout locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      {/* Hero */}
      <section className="my-16 md:my-20">
        <div className="container">
          <TwoColumns
            textClassName={`justify-start`}
            text={<TextCard blok={hero.textCard[0]} />}
            image={
              <div className="aspect-w-1 aspect-h-1 w-full">
                <div>
                  <Image blok={hero.asset[0]} />
                </div>
              </div>
            }
          />
        </div>
      </section>

      {content?.features && <FeatureGrid blok={content.features[0]} />}

      {content.imageSlider?.length > 0 && (
        <DynamicComponent blok={content.imageSlider[0]} />
      )}

      {content?.steps?.map((blok) => (
        <div key={blok._uid} className="my-20 md:my-28">
          <DynamicComponent blok={blok} />
        </div>
      ))}

      {content.moreFeatures?.length > 0 && <DynamicComponent blok={content.moreFeatures[0]} />}
      {content.builtForTeams?.length > 0 && <DynamicComponent blok={content.builtForTeams[0]} />}
      {content.logoStrip?.length > 0 && <DynamicComponent blok={content.logoStrip[0]} />}
      {content.visualContentSlider?.length > 0 && <DynamicComponent blok={content.visualContentSlider[0]} />}
      {content.grid2?.length > 0 && <Grid2 blok={content.grid2[0]} />}
    </Layout>
  );
};

export default HowItWorks;

export const query = graphql`
  query howItWorksQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
